(function () {
  function init(root) {
    if (!root || root.dataset.mcxInit === '1') return;
    root.dataset.mcxInit = '1';

    // Chips (team filter) — toggles visibility of matching grids via data-mcx-chip-target
    var chipGroup = root.querySelector('[data-mcx-chip-group]');
    if (chipGroup) {
      var chipTargets = root.querySelectorAll('[data-mcx-chip-target]');

      function showChipTarget(value) {
        chipTargets.forEach(function (el) {
          var match = el.getAttribute('data-mcx-chip-target') === value;
          if (match) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
      }

      chipGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mcx-chip]');
        if (!btn || !chipGroup.contains(btn)) return;
        chipGroup.querySelectorAll('[data-mcx-chip]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        showChipTarget(btn.getAttribute('data-mcx-chip'));
      });
    }

    // Partnership tabs
    var tabs = root.querySelector('[data-mcx-tabs]');
    if (tabs) {
      var panels = root.querySelectorAll('[data-mcx-panel]');
      var allTabs = tabs.querySelectorAll('[data-mcx-tab]');
      var band = root.querySelector('.mcx-whyus__band');
      var SCROLL_PER_TAB_VH = 0.8; // keep in sync with --mcx-whyus-tab-scroll in CSS

      function activateIndex(idx) {
        if (idx < 0) idx = 0;
        if (idx >= allTabs.length) idx = allTabs.length - 1;
        var btn = allTabs[idx];
        if (!btn) return;
        var current = tabs.querySelector('[data-mcx-tab].is-active');
        if (current === btn) return;
        allTabs.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var active = parseInt(p.getAttribute('data-mcx-panel'), 10) === idx;
          p.classList.toggle('is-active', active);
          if (active) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      }

      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mcx-tab]');
        if (!btn) return;
        var idxNum = parseInt(btn.getAttribute('data-mcx-tab'), 10);
        // Scroll the page to the corresponding pin offset; the scroll handler activates the tab.
        if (band) {
          var rect = band.getBoundingClientRect();
          var perTabPx = window.innerHeight * SCROLL_PER_TAB_VH;
          var currentScrolled = -rect.top;
          var targetScrolled = perTabPx * idxNum + perTabPx * 0.5;
          window.scrollBy({ top: targetScrolled - currentScrolled, behavior: 'smooth' });
        } else {
          activateIndex(idxNum);
        }
      });

      // Scroll-driven tab switching while the band is pinned (desktop / tablet only).
      if (band && allTabs.length > 0) {
        var rafPending = false;
        var onScrollUpdate = function () {
          if (rafPending) return;
          rafPending = true;
          requestAnimationFrame(function () {
            rafPending = false;
            var rect = band.getBoundingClientRect();
            var perTabPx = window.innerHeight * SCROLL_PER_TAB_VH;
            var scrolled = -rect.top;
            var idx = Math.floor(scrolled / perTabPx);
            if (idx < 0) idx = 0;
            if (idx >= allTabs.length) idx = allTabs.length - 1;
            activateIndex(idx);
          });
        };
        window.addEventListener('scroll', onScrollUpdate, { passive: true });
        window.addEventListener('resize', onScrollUpdate);
        onScrollUpdate();
      }
    }
  }

  function boot() {
    document.querySelectorAll('.mcx').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.mcx');
    if (section) init(section);
  });
})();
